export default __webpack_public_path__ + "static/media/j46.5d4dde5a.jpg";